module.exports = __webpack_public_path__ + "static/media/illustration.4acb0405.png";